import { Info } from "lucide-react";
import { useI18n } from "../lib/i18n";

/** Catatan penting untuk pemesanan menu resto & bento. */
export const RestoNotice = () => {
  const { t } = useI18n();
  return (
    <div
      data-testid="resto-notice"
      className="flex gap-3 rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3.5"
    >
      <Info size={18} className="mt-0.5 shrink-0 text-amber-600" />
      <div className="space-y-1">
        <p className="text-sm font-semibold text-amber-900">{t("resto_note_title")}</p>
        <ul className="text-sm text-amber-900/90 space-y-0.5 list-disc pl-4">
          <li>{t("resto_note_daily")}</li>
          <li>{t("resto_note_pickup")}</li>
          <li>{t("resto_note_no_lunch_delivery")}</li>
        </ul>
      </div>
    </div>
  );
};
